
const digest = '61e758b8aeb552388195a7f6360c9ac218840fce4c957c89633128076f93cb4b';
const classes = {"wrapper":"_wrapper_ccf2g_1","removeButton":"_removeButton_ccf2g_7"};
const css = `._wrapper_ccf2g_1 {
  position: relative;
  aspect-ratio: 1/1;
  border-radius: 15px;
  border: 1px solid #eaedf3;
}
._wrapper_ccf2g_1 ._removeButton_ccf2g_7 {
  position: absolute;
  height: 25px;
  width: 25px;
  top: -10px;
  right: -10px;
  background: #ffffff;
  border-radius: 100%;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  